import {combineReducers} from '@reduxjs/toolkit';

import {presetsStateSlice} from './slices/presets-state.slice';
import {presetsSlice} from './slices/presets.slice';

export const presetsReducer = combineReducers({
    presets: presetsSlice.reducer,
    presetsState: presetsStateSlice.reducer,
});
